import { format } from "date-fns"
import { utcToZonedTime } from "date-fns-tz"

// by convention, composable function names start with "use"
export function useDateTimeHelper(utcDate: Date | string) {
	// Handle null/undefined input by returning empty string functions
	if (!utcDate) {
		return {
			toLocalTimeZoneString: () => "",
			toLocalTimeZone: () => "",
			toLocalTimeZoneStandardFormat: () => "",
			toLocalTimeZoneDateStandardFormat: () => "",
		}
	}
	// Convert input to UTC Date, stripping any existing timezone info and treating as UTC
	if (!utcDate) {
		return {
			toLocalTimeZoneString: () => "",
			toLocalTimeZone: () => "",
			toLocalTimeZoneStandardFormat: () => "",
			toLocalTimeZoneDateStandardFormat: () => "",
		}
	}
	const utcDateObj =
		typeof utcDate === "string"
			? new Date(utcDate.replace(/[+-]\d{2}:\d{2}$|Z$/g, "") + "Z") // Strip timezone and add Z
			: new Date(
					utcDate.getUTCFullYear(),
					utcDate.getUTCMonth(),
					utcDate.getUTCDate(),
					utcDate.getUTCHours(),
					utcDate.getUTCMinutes(),
					utcDate.getUTCSeconds(),
					utcDate.getUTCMilliseconds()
				) // Create new Date using UTC components

	function toLocalTimeZoneString() {
		if (utcDateObj instanceof Date === false || isNaN(utcDateObj.getTime())) {
			return ""
		}
		const localDateTime = toLocalTimeZone()
		return localDateTime.toLocaleString() + " " + localDateTime.toLocaleString()
	}

	function toLocalTimeZone() {
		if (utcDateObj instanceof Date === false || isNaN(utcDateObj.getTime())) {
			return ""
		}
		const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
		const localDateTime = utcToZonedTime(utcDateObj, localTimeZone)
		return localDateTime
	}

	function toLocalTimeZoneStandardFormat() {
		if (utcDateObj instanceof Date === false || isNaN(utcDateObj.getTime())) {
			return ""
		}
		const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
		const localDateTime = utcToZonedTime(utcDateObj, localTimeZone)
		return format(localDateTime, "MMM dd, yyyy h:mm aa")
	}
	function toLocalTimeZoneDateStandardFormat() {
		if (utcDateObj instanceof Date === false || isNaN(utcDateObj.getTime())) {
			return ""
		}
		const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
		const localDateTime = utcToZonedTime(utcDateObj, localTimeZone)
		return format(localDateTime, "MMM dd, yyyy")
	}
	return { toLocalTimeZoneString, toLocalTimeZone, toLocalTimeZoneStandardFormat, toLocalTimeZoneDateStandardFormat }
}

// Standalone function for export filename timestamps
export function formatExportTimestamp(): string {
	const now = new Date()
	const year = now.getFullYear()
	const monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"]
	const month = monthNames[now.getMonth()]
	const day = String(now.getDate()).padStart(2, "0")
	const hours = String(now.getHours()).padStart(2, "0")
	const minutes = String(now.getMinutes()).padStart(2, "0")
	const seconds = String(now.getSeconds()).padStart(2, "0")

	return `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`
}
